import React from "react";
import { useTranslation } from "react-i18next";
import { useAuth0 } from "@auth0/auth0-react";

const CheckoutPaypalButton = (props) => {
  const { t } = useTranslation();
  const { loginWithRedirect } = useAuth0();
  return (
    <div className="row g-4 justify-content-center">
  <div className="col-md-5">
    <div className="card h-100 shadow border-0 donate-card">
      <div className="card-body text-center p-4">
        <div className="display-4 mb-3">👤</div>

        <h2 className="h4 mb-3">{t("donate-use-account")}</h2>

        <p className="text-muted mb-4">
          {t("donate-smoother-login")}
        </p>

        <button
          className="btn btn-primary btn-lg px-4"
          onClick={async () =>
            await loginWithRedirect({
              appState: { returnTo: window.location.pathname },
            })
          }
        >
          {t("login")}
        </button>
      </div>
    </div>
  </div>

  <div className="col-md-5">
    <div className="card h-100 shadow">
      <div className="card-body text-center p-4">
        <div className="display-4 mb-3">❤️</div>

        <h2 className="h4 mb-3">{t("donate-as-guest")}</h2>

        <p className="text-muted mb-4">
          {t("donate-with-paypal")}
        </p>

        <a
          className="btn btn-primary btn-lg px-4"
          href="https://collectcheckout.com/r/twr19"
          target="_blank"
          rel="noreferrer"
        >
          {t("donate")}
        </a>
      </div>
    </div>
  </div>
</div>
  );
};

export default CheckoutPaypalButton;
